import { useContext, useMemo } from "react";
import { AppContext } from "../../root/Root";
import { CreativeReviewContext } from "../../../contexts/contexts";
import { DefaultLayout } from "../../../layouts/DefaultLayout";
import Grid from "@mui/material/Unstable_Grid2";
import { CreativeReview } from "../../../components/eRetail/creativeReview/CreativeReview";
import { PoolMetadata } from "../../../components/eRetail/poolMetadata/PoolMetadata";
import { useValidVisual } from "../../../hooks/eRetail/useValidVisual";
import useMappingKeyStatus from "../../../hooks/eRetail/useMappingKeyStatus";
import useReviewCreative from "../../../hooks/eRetail/useReviewCreative";
import { DATA_SOURCE } from "../../../constants";
import "../../../style/common.scss";

const metadataComponent = (props) => <PoolMetadata {...props} isReview />;

export const Level3 = () => {
  useContext(AppContext);

  const useReviewCreativeOutput = useReviewCreative();

  const contextValue = useMemo(
    () => ({
      metadataComponent,
      useValidVisual,
      useMappingKeyStatus,
    }),
    [],
  );

  return (
    <DefaultLayout>
      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid xs={12}>
          <CreativeReviewContext.Provider value={contextValue}>
            <CreativeReview
              dataSource={DATA_SOURCE.eRetail}
              useReviewCreativeOutput={useReviewCreativeOutput}
            />
          </CreativeReviewContext.Provider>
        </Grid>
      </Grid>
    </DefaultLayout>
  );
};
